<div class='head'>
    <div class='container'>
        <h1 class='contact'>
            About us
        </h1>
        <p>
            <span class='subtitle'>FoodD is on a Mission to Transform the Way Customers Eat</span>
        </p>
    </div>
</div>
<br /><br />

<div class='container'>
    <div class='row'>
        <div class='col-md-6 col-12'>
            <p class='title'>
                OUR MISSION
            </p>
            <p class='text'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pharetra metus metus, vitae consequat justo facilisis at. Nunc vestibulum augue iaculis augue bibendum iaculis. Integer sollicitudin laoreet sapien et vehicula.<br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pharetra metus metus, vitae consequat justo facilisis at. Nunc vestibulum augue iaculis augue bibendum iaculis. Integer sollicitudin laoreet sapien et vehicula.
            </p>
        </div>
        <div class='col-md-6 col-12'>
            <p class='title'>
                OUR VISION
            </p>
            <p class='text'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pharetra metus metus, vitae consequat justo facilisis at. Nunc vestibulum augue iaculis augue bibendum iaculis. Integer sollicitudin laoreet sapien et vehicula.<br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pharetra metus metus, vitae consequat justo facilisis at. Nunc vestibulum augue iaculis augue bibendum iaculis. Integer sollicitudin laoreet sapien et vehicula.
            </p>
        </div>
    </div>
    <br />
    
    <div class="='row">
        <div class='col-md-12 col-12'>
            <p class='first_block'>
                650k + <br /><br /> Cities
            </p>
            <p class='second_block'>
                650k + <br /><br /> Customer
            </p>
            <p class='third_block'>
                650k + <br /><br /> Partners
            </p>
        </div>
    </div>
    <br /><br />

    <div class='team_title'>
        <p>
            Meet Our Team
        </p>
        <hr />
    </div>
    <br />
    <div class='row'>
        <div class='col-md-4 col-12' style='text-align: center;'>
            <img src='assets/images/try.jpg' alt='...' class='circle' width="200" height="200" /><br />    <br />

            <h2>Mr. CEO NAME</h2>
        </div>
        <div class='col-md-4 col-12' style='text-align: center;'>
            <img src='assets/images/try.jpg' alt='...' class='circle' width="200" height="200" /><br />    <br />

            <h2>Mr. CEO NAME</h2>
        </div>
        <div class='col-md-4 col-12' style='text-align: center;'>
            <img src='assets/images/try.jpg' alt='...' class='circle' width="200" height="200" /><br />    <br />

            <h2>Mr. CEO NAME</h2>
        </div>
    </div>
    <br />
    <br />

</div>